import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`As an npm user with a paid user account, you can add another npm user with a paid account as a collaborator on a private package you own.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` The user you want to add as a collaborator on your private package must have a paid user account. To sign up for a paid account, they can visit `}<inlineCode parentName="p">{`https://www.npmjs.com/settings/username/billing`}</inlineCode>{`, replacing `}<inlineCode parentName="p">{`username`}</inlineCode>{` with their npm username.`}</p>
    </Note>
    <p>{`When you add a member to your package, they are sent an email inviting them to the package. The new member has to accept the invitation gain access to the package.`}</p>
    <h2>{`Granting access to a private user package on the web`}</h2>
    <ol>
      <li parentName="ol">{`On the `}<a parentName="li" {...{
          "href": "https://npmjs.com"
        }}>{`npm website`}</a>{`, go to the package to which you want to add a collaborator: `}<inlineCode parentName="li">{`https://www.npmjs.com/package/<your-package-name>`}</inlineCode></li>
      <li parentName="ol">{`On the package page, under "Collaborators", click `}<strong parentName="li">{`+`}</strong>{`.`}</li>
      <li parentName="ol">{`Enter the npm username of the collaborator.`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Submit`}</strong>{`.`}</li>
    </ol>
    <h2>{`Granting private package access from the command line interface`}</h2>
    <p>{`To add a collaborator to a package on the command line, run the following command, replacing `}<inlineCode parentName="p">{`<user>`}</inlineCode>{` with the npm username of your collaborator, and `}<inlineCode parentName="p">{`<your-package-name>`}</inlineCode>{` with the name of the private package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm owner add <user> <your-package-name>
`}</code></pre>
    <h2>{`Granting access to private organization packages`}</h2>
    <p>{`To grant an npm user access to private organization packages, you must have an organization owner add them to your organization, then add them to a team that has access to the private package. For more information, see "`}<a parentName="p" {...{
        "href": "adding-members-to-your-organization"
      }}>{`Adding members to your organization`}</a>{`".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      